import { Directive, inject, effect, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserStore } from 'app/core/services/user.store';

/**
 * Structural directive that removes its host element for onboarding accounts
 * (`userRole.onboarding`). Onboarding users are still completing their
 * registration and should not yet see chrome that belongs to a fully
 * provisioned account — global search, the widget sidebar, and the profile /
 * company-settings shortcuts. Route access is already blocked by the auth
 * guards; this hides the affordances so they are never offered.
 */
@Directive({
  selector: '[hideForOnboarding]',
  standalone: true,
})
export class HideForOnboardingDirective {
  isHidden = true;

  readonly #userStore = inject(UserStore);
  readonly #templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  readonly #viewContainer = inject(ViewContainerRef);

  constructor() {
    effect(() => {
      if (this.#userStore.currentUser()) {
        this.updateView();
      }
    });
  }

  private updateView() {
    if (this.showElement() && this.isHidden) {
      this.#viewContainer.createEmbeddedView(this.#templateRef);
      this.isHidden = false;
    } else if (!this.showElement()) {
      this.isHidden = true;
      this.#viewContainer.clear();
    }
  }

  private showElement() {
    return !this.#userStore.isOnboarding();
  }
}
